module.exports = __webpack_public_path__ + "img/icon-article_gray.552cb213.svg";